var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sc-btn",class:[
    _vm.btnVariant,
    _vm.btnSize,
    _vm.btnOutlined,
    _vm.btnBlocked,
    _vm.btnRounded,
    _vm.btnSquared
  ],attrs:{"type":_vm.type,"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }